import { z } from 'zod'
import { oc } from '@orpc/contract'
import { boardItemSchema } from '../../boards/handlers/boards-shared.contract'
import { outgoingFaxMessageId } from './link-outgoing-fax.contract'

/**
 * Remove a sent fax from a task's record (PD-1606). POST, not DELETE: symmetric
 * with the link route, and it keeps the message id in the body rather than in a
 * path segment.
 */
export const unlinkOutgoingFax = oc
  .route({ method: 'POST', path: '/v2/fax-tasks/outgoing-links/remove' })
  .input(z.object({ itemId: z.string().min(1), messageId: outgoingFaxMessageId }))
  .output(z.object({ item: boardItemSchema }))
